<template>
  <vs-popup class="customer-sample-order-create-popup" id="popup" title="RETURN TO AVAILABLE STOCK"
    @close="open = false" :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>
      <div class="vx-row mb-3">
        <div class="vx-col w-full"> {{ stock_form.manufacture_date }}
          <small class="label">Manufacture Date</small>
          <flat-pickr disabled :config="{ dateFormat: 'd/m/Y' }" class="hidden"
            v-model="stock_form.manufacture_date" placeholder="Choose Manufacture Date" />

          <flat-pickr disabled :config="{ dateFormat: 'd/m/Y'}" class="w-full"
            v-model="stock_form.manufacture_date" placeholder="Choose Manufacture Date" />
        </div>
      </div>
      <div class="vx-row mb-3">
        <div class="vx-col w-full">
          <small class="label">Expiration Date</small>
          <flat-pickr :config="{ dateFormat: 'd/m/Y' }" class="hidden"
            v-model="stock_form.expiration_date" placeholder="Choose Expiration Date" />

          <flat-pickr :config="{ dateFormat: 'd/m/Y' }" class="w-full"
            v-model="stock_form.expiration_date" placeholder="Choose Expiration Date" />
        </div>
      </div>

      <small>Shelf Location</small>
      <div class="vx-row mb-3">
        <div class="vx-col w-1/3">
          <ValidationProvider vid="shelf_location_r" name="shelf_location_r" rules="" v-slot="{ errors }">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text bg-primary">
                  <span>R</span>
                </div>
              </template>
              <vs-input v-model="stock_form.shelf_location_r" name="invoice_number" class="w-full required" label=""
                val-icon-danger="icon-x" val-icon-pack="feather" />
            </vx-input-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </ValidationProvider>
        </div>
        <div class="vx-col w-1/3">
          <ValidationProvider vid="shelf_location_s" name="shelf_location_s" rules="" v-slot="{ errors }">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text bg-primary">
                  <span>S</span>
                </div>
              </template>
              <vs-input v-model="stock_form.shelf_location_s" name="shelf_location_s" class="w-full required" label=""
                val-icon-danger="icon-x" val-icon-pack="feather" />
            </vx-input-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </ValidationProvider>
        </div>
        <div class="vx-col w-1/3">
          <ValidationProvider vid="shelf_location_l" name="shelf_location_l" rules="" v-slot="{ errors }">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text bg-primary">
                  <span>L</span>
                </div>
              </template>
              <vs-input v-model="stock_form.shelf_location_l" name="shelf_location_l" class="w-full required" label=""
                val-icon-danger="icon-x" val-icon-pack="feather" />
            </vx-input-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </ValidationProvider>
        </div>
      </div>
      <div class="vx-row mb-3">
        <div class="vx-col w-full">
          <small class="label">Note</small>
          <vs-textarea class="mb-0" v-model="stock_form.reason" height="70px" />
        </div>
      </div>

      <div class="flex flex-wrap items-center justify-end mt-8">
        <vs-button @click="onClickSave()" button="submit" color="primary" class="ml-auto mt-2">Save Changes</vs-button>
      </div>

    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const InventoryRepository = RepositoryFactory.get('inventory');
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

function initialState() {
  return {
    open: false,
    id: '',
    stock_data: {},
    stock_form: {
      shelf_location_r: '',
      shelf_location_s: '',
      shelf_location_l: '',
      manufacture_date: '',
      expiration_date: '',
    },
  }
}

export default {
  name: 'RmWasteSendBackToStockPopUp',
  data() {
    return initialState()
  },
  components: {
      flatPickr,
    },
  methods: {
    async openPopup(stock_data) {
      try {
        await Object.assign(this.$data, initialState())
        Object.assign(this.stock_data, stock_data)
        this.stock_form.manufacture_date = this.stock_data.manufacture_date
        this.stock_form.expiration_date = this.stock_data.expiration_date
        this.stock_form.shelf_location_r = this.stock_data.shelf_location_r
        this.stock_form.shelf_location_s = this.stock_data.shelf_location_s
        this.stock_form.shelf_location_l = this.stock_data.shelf_location_l
        this.open = true
      } catch (error) {
        this.convertAndNotifyError(error);
      }
    },
    async onClickSave() {
      try {
        await InventoryRepository.sendWasteItemToStock(this.stock_data.id, this.stock_form)
        this.showSuccessMessage('RM waste send back to stock successfully')
        this.$emit('refreshData')
        this.open = false
      } catch (error) {
        this.convertAndNotifyError(error)
      }
    }
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.customer-sample-order-create-popup>>>.vs-popup {
  /*min-height: 78% !important;*/
  min-width: 20% !important;
}
</style>
